import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const NavigateRightUpFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function NavigateRightUpFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M22.1 1.89c-.65-.65-1.61-.88-2.49-.6L2.9 6.64c-.38.12-.72.33-1 .61-1.29 1.29-.79 3.48.93 4.09l7.26 2.57 2.57 7.26c.61 1.72 2.8 2.22 4.09.93.28-.28.49-.62.61-1l5.35-16.71c.28-.88.05-1.84-.6-2.49l-.01-.01Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default NavigateRightUpFilled;